import { queryOptions } from '@tanstack/react-query';
import { getPrinters } from '@/features/printing/presentation/actions/get-printers';

export const printersKeys = {
  all: ['printers'] as const,
  list: (locationUuid: string | undefined) => [...printersKeys.all, locationUuid] as const,
};

/** Estado del servicio local de impresión (health check); raíz propia para no mezclarse con `printersKeys.all`. */
export const printersServiceKeys = {
  all: ['printers-service'] as const,
};

export const printersQueryOptions = (locationUuid: string | undefined) =>
  queryOptions({
    queryKey: printersKeys.list(locationUuid),
    queryFn: () => getPrinters({ locationId: locationUuid ?? '' }),
    enabled: !!locationUuid,
  });
